import { RoutePath } from "#src/utils/route";
import { RootRoute } from "../root";

export * from "./DashboardPage";

/** @deprecated - Use new RoutePath pattern */
export const DASHBOARD_TITLE = "Dashboard";

/** @deprecated - Use new RoutePath pattern */
export const linkToDashboards = () => "/app/dashboards";

/** @deprecated - Use new RoutePath pattern */
export const DASHBOARDS_BREADCRUMB = {
  title: "Dashboards",
  path: linkToDashboards,
};

export const DashboardsRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/dashboards",
    title: "Dashboards",
    isPresentational: true,
  })
);

export const ManageInsightsRoutePath = DashboardsRoutePath.concat(
  new RoutePath({
    path: "/manage-insights",
    title: "Manage Insights",
  })
);
